import React from 'react';
import {Popover} from 'react-bootstrap';
import {parseHtmlString} from 'shared/helpers/HTMLParser';
import styled from 'styled-components';

interface NewSelectionPopoverProps {
    image?: string;
    title?: string;
    description?: string;
    wide?: boolean;
    show?: boolean;
    selected?: boolean;
}

export const NewSelectionPopover = ({
    wide = true,
    image,
    title,
    description,
    show = false,
    selected = false,
}: NewSelectionPopoverProps) => {
    return (
        <LocalPopover placement="bottom" id={`${title}-popover`} $show={show}>
            <Title $selected={selected}>
                <strong>{title}</strong> - {parseHtmlString(description)}
            </Title>
            <Content>
                <Image src={image} $wide={wide} />
            </Content>
        </LocalPopover>
    );
};

const LocalPopover = styled(Popover)<{$show: boolean}>`
    display: ${({$show}) => ($show ? 'block' : 'none')};
    width: 400px;
    max-width: 400px;
    max-height: 500px;
    z-index: 1000;

    padding: 0;
    border: none;

    margin-top: 30px;

    .popover-arrow {
        display: none;
    }

    .popover-header {
        margin: 0;
        border-radius: 0;
    }
`;

const Title = styled(Popover.Header)`
    background: rgb(var(--secondary_colour));
    font-weight: 500;
    font-size: 1em;
    color: white;

    ${({$selected}) =>
        $selected &&
        `
        background: rgb(var(--primary_colour));
    `}
`;

const Content = styled(Popover.Body)`
    text-align: center;
    border-top: 0;
    padding: 0;
`;

const Image = styled.img<{$wide: boolean}>`
    width: ${({$wide}) => (!$wide ? '200px' : '400px')} !important;
    height: ${({$wide}) => (!$wide ? '250px' : '400px')} !important;

    transition: transform 0.3s ease;
    transform-origin: center;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
`;
